import { SETTINGS_MODE } from 'shared/enums';
import { ITabList } from 'interfaces/utils';

import PolicyList from 'components/PolicyList';
import IdentityList from 'components/IdentityList';

export const tabs = {
  [SETTINGS_MODE.users]: {
    Component: IdentityList,
    label: 'Usuários',
    key: 'identity',
  },
  [SETTINGS_MODE.policies]: {
    Component: PolicyList,
    label: 'Perfis',
    key: 'policy',
  },
} as ITabList;

export const tabsEntries = Object.entries(tabs);
